import React, {useState} from "react";
import {DatePicker, Input, Modal, Typography, message} from "antd";
import {useStore} from "hooks/useStore";
import moment from "moment";
import locale from "antd/es/date-picker/locale/tr_TR";
const {Text} = Typography;

const TODAY = moment();

export const StartLeaveModal = ({visible, onClose, courierId, onSuccess}) => {
    const stores = useStore();
    const [loading, setLoading] = useState(false);
    const [endDate, setEndDate] = useState(null);
    const [reason, setReason] = useState("");

    const handleOk = async () => {
        if (!endDate) {
            message.error("Lütfen bitiş tarihi seçin");
            return;
        }
        if (!reason) {
            message.error("Lütfen izin nedeni giriniz");
            return;
        }
        setLoading(true);
        try {
            const result = await stores.courierStore.startLeave(courierId, {
                startDate: TODAY.toISOString(),
                endDate: moment(endDate)
                    .endOf("day")
                    .toISOString(),
                reason: reason
            });
            if (result.success) {
                setEndDate(null);
                setReason("");
                onClose();
                onSuccess();
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setEndDate(null);
        setReason("");
        onClose();
    };

    return (
        <Modal
            title="İzin Tarihi Seçin"
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Kaydet"
            cancelText="İptal"
            confirmLoading={loading}
        >
            <Text type="secondary" style={{display: "block", marginBottom: 16}}>
                Kuryenin izin kullanacağı tarih aralığını girdikten sonra kaydet butonuna
                basıldığında kurye belirtilen tarihler arasında pasif/izinli statüsüne alınır
            </Text>
            <div style={{marginBottom: 8}}>
                <label>İzin Başlangıç Tarihi</label>
                <DatePicker
                    style={{width: "100%", marginTop: 4}}
                    format="DD.MM.YYYY"
                    value={moment()}
                    locale={locale}
                    disabled
                />
            </div>
            <div>
                <label>
                    İzin Bitiş Tarihi <span style={{color: "red"}}>*</span>
                </label>
                <DatePicker
                    style={{width: "100%", marginTop: 4}}
                    format="DD.MM.YYYY"
                    value={endDate}
                    onChange={date => setEndDate(date)}
                    placeholder="Bitiş tarihi seçin"
                    disabledDate={current => current && current.isBefore(moment(), "day")}
                    locale={locale}
                />
            </div>
            <div style={{marginTop: 8}}>
                <label>
                    İzin Nedeni <span style={{color: "red"}}>*</span>
                </label>
                <Input.TextArea
                    rows={3}
                    style={{
                        width: "100%",
                        marginTop: 4,
                        resize: "none"
                    }}
                    maxLength={500}
                    showCount
                    value={reason}
                    onChange={e => setReason(e.target.value)}
                    placeholder="İzin nedeni giriniz"
                />
            </div>
        </Modal>
    );
};
